export { DMS_MODULE } from '../constants';
export const NAME = 'SkladOjetychVozu';
export const CRUMB_LABEL_KEY = 'edtSkladov';

export const TAB_NAMES = <const>{
	ZAKLADNI_INFORMACE: 'ZakladniInformace',
	TECH_STAV_1: 'TechStav1',
	TECH_STAV_2: 'TechStav2',
	OSTATNI: 'Ostatni',
	TEXTY: 'Texty',
};
